module.exports = __webpack_public_path__ + "static/img/banner5.f3c7992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner5.png
// module id = nnUB
// module chunks = 127